export var convertToLocalMidnight=function(a){var b=new Date(a.split("T")[0]);// using YYYY-MM-DD creates UTC date
return new Date(b.getUTCFullYear(),b.getUTCMonth(),b.getUTCDate())};